module.exports = __webpack_public_path__ + "static/sombra-celular-0ed29f4c1cc8e57393a3ecc9604c1112.png";